export default [
    {
        key: 'jurisdiction-province-detail',
        kind: 'detail',
        fields: [
            {
                key: 'id',
                primaryKey: true
            },
            {
                key: 'title',
                formatter: {
                    type: 'title',
                    args: {
                        title: 'name',
                        subtitle: 'code',
                        visible: true,
                        col: 24,
                        group: 'basic-no-border'
                    }
                }
            },
            {
                key: 'name',
                formatter: {
                    type: 'text',
                    args: {
                        visible: false
                    }
                }
            },
            {
                key: 'code',
                formatter: {
                    type: 'text',
                    args: {
                        visible: false
                    }
                }
            },
            {
                key: 'staffName',
                label: '辖区人员',
                formatter: {
                    type: 'text',
                    args: {
                        visible: true,
                        group: 'basic-no-border'
                    }
                }
            },
            {
                key: 'jurisdictionType',
                label: '辖区类型',
                formatter: {
                    type: 'text',
                    args: {
                        visible: true,
                        group: 'basic-no-border'
                    }
                }
            },
            {
                key: 'roleName',
                label: '角色',
                formatter: {
                    type: 'text',
                    args: {
                        visible: true,
                        group: 'basic-no-border'
                    }
                }
            }
        ]
    }
]